webpackJsonp([114276838955818,60335399758886],{

/***/ 99:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(234);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(99);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  siteMetadata: {
	    title: "Code Sculpture: Create 3D art from simple rules (from James Porter)"
	  },
	  plugins: ["gatsby-plugin-react-helmet", "gatsby-plugin-react-next", "gatsby-plugin-typescript"]
	};

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(312);
	var isArguments = __webpack_require__(311);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 311:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 312:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(557);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(310);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(539);
	
	var _HelmetConstants = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(70);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(327));
	var shallowEqual = _interopDefault(__webpack_require__(126));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 126:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    "div",
	    { className: "footer" },
	    _react2.default.createElement(
	      "div",
	      { className: "footer-outer" },
	      _react2.default.createElement(
	        "div",
	        { className: "footer-links" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Me, elsewhere"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "footer-link-container" },
	          _react2.default.createElement(
	            "a",
	            { href: "https://twitter.com/complexview" },
	            "Twitter"
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://github.com/jamesporter" },
	            "Github"
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.linkedin.com/profile/view?id=39625869" },
	            "LinkedIn"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "footer-links" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "My other sites"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "footer-link-container" },
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.amimetic.co.uk" },
	            "Other Projects"
	          ),
	          _react2.default.createElement(
	            "a",
	            { href: "https://complexview.com" },
	            "Complex View (My main site)"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _storeLinks = __webpack_require__(35);
	
	var _storeLinks2 = _interopRequireDefault(_storeLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    "div",
	    { className: "header" },
	    _react2.default.createElement(
	      "div",
	      { className: "header-container" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/", className: "header-home" },
	        "Code Sculpture"
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "description" },
	        "The iPhone and iPad App to create 3D Art from Simple Rules",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://complexview.com" },
	          "(from James Porter)"
	        ),
	        "."
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "header-links" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/", exact: true, activeClassName: "active" },
	          "Introduction"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/editor", activeClassName: "active" },
	          "Editor"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/lessons", activeClassName: "active" },
	          "Video Lessons"
	        )
	      ),
	      _react2.default.createElement(_storeLinks2.default, { iOSStoreLink: "https://itunes.apple.com/us/app/code-sculpture/id1286544769" })
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var __importDefault = undefined && undefined.__importDefault || function (mod) {
	    return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __importDefault(__webpack_require__(1));
	var googleStoreImage_png_1 = __importDefault(__webpack_require__(46));
	var iOSStoreImage_png_1 = __importDefault(__webpack_require__(47));
	var StoreLinks = function StoreLinks(_ref) {
	    var androidStoreLink = _ref.androidStoreLink,
	        iOSStoreLink = _ref.iOSStoreLink,
	        webLink = _ref.webLink,
	        title = _ref.title;
	    return react_1.default.createElement("div", { className: "store-links" }, iOSStoreLink && react_1.default.createElement("a", { href: iOSStoreLink, target: "_blank" }, react_1.default.createElement("img", { src: iOSStoreImage_png_1.default, alt: "Download " + title + " from Apple App Store", style: { width: 135, height: 40 } })), androidStoreLink && react_1.default.createElement("a", { href: androidStoreLink, target: "_blank" }, react_1.default.createElement("img", { src: googleStoreImage_png_1.default, alt: "Download " + title + " from Google Play", style: { width: 135, height: 40 } })), webLink && react_1.default.createElement("a", { href: webLink, alt: "" + title, target: "_blank" }, react_1.default.createElement("div", { className: "webLink" }, title.length < 16 ? title : "Web")));
	};
	exports.default = StoreLinks;

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/googleStoreImage.7a60f99f.png";

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(538);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(231);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(229);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _gatsbyConfig = __webpack_require__(217);
	
	var _gatsbyConfig2 = _interopRequireDefault(_gatsbyConfig);
	
	__webpack_require__(329);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Code Sculpture (from James Porter)",
	      meta: [{ name: "description", content: "Create 3D art from simple rules" }]
	    }),
	    _react2.default.createElement(_header2.default, null),
	    _react2.default.createElement(
	      "div",
	      { className: "content" },
	      children()
	    ),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-0b37ed714f5b3a0ef477.js